<aside class="sidebar-wrapper" [class.expanded]="isExpanded">
  <div
    class="logo-wrapper mb-0 d-flex align-items-center justify-content-between"
  >
    <div>
      <img src="Logo.png" class="bg-transparent" alt="">  
    </div>
    <button (click)="expandSideBar()" type="button" class="animated-toggle-btn">
      <!-- <i [ngClass]="{
        'bi bi-arrow-bar-left': isExpanded,
        'bi bi-arrow-bar-right': !isExpanded
      }"></i> -->
      <span> </span>
    </button>
  </div>
  <div class="menu-wrapper">
    <ul class="main-menu">
      <div class="user-menu" *ngIf="user.tokenValue.role == 'user'">
        <li class="menu-category">
          <span class="menu-category-name">User</span>
        </li>
        <li class="menu-item" *ngIf="user.tokenValue.role == 'user'">
          <a class="nav-link" routerLink="/user" routerLinkActive="active">
            <i class="bi bi-grid"></i>
            <span>Dashboard</span>
          </a>
        </li>
      </div>
      <div class="admin-menu" *ngIf="user.tokenValue.role == 'admin'">
        <li class="menu-category">
          <span class="menu-category-name">Admin</span>
        </li>
        <li class="menu-item">
          <a
            class="nav-link"
            routerLink="/admin"
            routerLinkActive="active"
          >
            <i class="bi bi-grid"></i>
            <span>Dashboard</span>
          </a>
        </li>
        <li class="menu-item">
          <a
            class="nav-link"
            routerLink="/addcontent"
            routerLinkActive="active"
          >
            <i class="bi bi-file-earmark-plus"></i><span>Add Content</span>
          </a>
        </li>
        <li class="menu-item">
          <a
            class="nav-link"
            routerLink="configurations"
            routerLinkActive="active"
          >
            <i class="bi bi-people"></i><span>Manage Configurations</span>
          </a>
        </li>
      </div>
      <li class="menu-item">
        <a class="nav-link"
        routerLink="profile"
        routerLinkActive="active"
        >
          <i class="bi bi-person"></i><span>Profile</span>
        </a>
      </li>
    </ul>
  </div>
</aside>
